import { Phone, MessageCircle, FileText } from "lucide-react";
import { CONTACT } from "@/data/content";
import { trackEvent, EVENTS } from "@/lib/analytics";
import { scrollToHash } from "@/components/Navbar";

export const FloatingCTA = () => (
    <>
        <div className="fixed inset-x-3 bottom-3 z-40 md:hidden" data-testid="mobile-floating-cta">
            <div className="grid grid-cols-3 gap-1 rounded-full border border-white/15 bg-omsivo-deep/90 p-1.5 shadow-2xl shadow-black/50 backdrop-blur-xl">
                <a href={CONTACT.phoneTel} onClick={() => trackEvent(EVENTS.phoneClick, { location: "floating" })}
                    data-testid="floating-call-btn"
                    className="flex items-center justify-center gap-1.5 rounded-full py-2.5 font-display text-[11px] font-bold uppercase tracking-wider text-white">
                    <Phone className="h-3.5 w-3.5 text-flame" /> Call
                </a>
                <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer"
                    onClick={() => trackEvent(EVENTS.whatsappClick, { location: "floating" })}
                    data-testid="floating-whatsapp-btn"
                    className="flex items-center justify-center gap-1.5 rounded-full py-2.5 font-display text-[11px] font-bold uppercase tracking-wider text-white">
                    <MessageCircle className="h-3.5 w-3.5 text-flame" /> WhatsApp
                </a>
                <button onClick={() => { trackEvent(EVENTS.estimateClick, { location: "floating" }); scrollToHash("#contact"); }}
                    data-testid="floating-estimate-btn"
                    className="flex items-center justify-center gap-1.5 rounded-full bg-flame py-2.5 font-display text-[11px] font-bold uppercase tracking-wider text-white">
                    <FileText className="h-3.5 w-3.5" /> Estimate
                </button>
            </div>
        </div>

        <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp"
            onClick={() => trackEvent(EVENTS.whatsappClick, { location: "floating_desktop" })}
            data-testid="floating-whatsapp-desktop"
            className="ping-soft fixed bottom-7 right-7 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-flame text-white shadow-xl shadow-flame/30 transition-transform hover:-translate-y-1 md:flex">
            <MessageCircle className="h-6 w-6" />
        </a>
    </>
);
